export const redirects = [
  // {
  //   path: "/",
  //   redirect: "/editor",
  // },
];

export const staticRoutes = [
  {
    path: "/",
    name: "index",
    component: () => import("@/pages/homepage/index.vue"),
    meta: {
      // layout: "blank",
      public: true,
      isTransparentHeader: true,
    },
  },
];
